import { apiService } from '../../shared/services/apiService';
import {
  CorporateAccount,
  CorporateAccountFormValues,
  CorporateAccountsResponse,
} from '../interfaces/CorporateAccount';

const urlBase = '/api/admin/corp';

export const corporateAccountsService = {
  async getCorporateAccounts() {
    const resp = await apiService.get<CorporateAccountsResponse>(
      `${urlBase}/get-all-accounts`,
    );

    return resp.data;
  },
  async deleteCorporateAccount(id: number) {
    await apiService.delete(`${urlBase}/account/${id}`);
  },
  async createCorporateAccount(data: CorporateAccountFormValues) {
    const resp = await apiService.post<CorporateAccount>(`${urlBase}/account`, data);

    return resp.data;
  },
  async editCorporateAccount(data: CorporateAccountFormValues, id: number) {
    const resp = await apiService.put<CorporateAccount>(`${urlBase}/account/${id}`, data);

    return resp.data;
  },
};
